import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MagneticButton } from './MagneticButton';
import { useContent } from '../content/ContentProvider';
import '../styles/glass.css';

interface NavigationProps {
  property?: 'mobile' | 'desktop';
}

export const Navigation: React.FC<NavigationProps> = () => {
  const { nav } = useContent();
  const NAV_ITEMS = nav.items;
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = async (section: string) => {
    setMenuOpen(false);
    if (location.pathname !== '/') {
      await navigate('/');
      await new Promise((r) => setTimeout(r, 100));
    }
    const element = document.getElementById(section);
    if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav className="nav-pill">
      <div className="nav-pill-inner glass-strong">
        <button
          className="nav-brand"
          onClick={() => {
            navigate('/');
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          style={{ background: 'transparent', border: 0, cursor: 'pointer' }}
        >
          {nav.brand}
        </button>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <button key={item.id} className="nav-link" onClick={() => handleNavigation(item.id)}>
              {item.label}
            </button>
          ))}
          <MagneticButton className="nav-link cta" onClick={() => handleNavigation('contact')} strength={0.25}>
            {nav.cta}
          </MagneticButton>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden nav-link"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          style={{ marginLeft: 'auto' }}
        >
          <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {menuOpen && (
        <div
          className="md:hidden glass-strong"
          style={{
            position: 'absolute',
            top: 60,
            left: 16,
            right: 16,
            padding: 12,
            borderRadius: 22,
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              className="nav-link"
              onClick={() => handleNavigation(item.id)}
              style={{ textAlign: 'left', width: '100%' }}
            >
              {item.label}
            </button>
          ))}
          <button
            className="nav-link cta"
            onClick={() => handleNavigation('contact')}
            style={{ textAlign: 'left' }}
          >
            {nav.cta}
          </button>
        </div>
      )}
    </nav>
  );
};
